import {
  defineStyleConfig,
  extendTheme,
} from '@chakra-ui/react';
import { theme as proTheme } from '@chakra-ui/pro-theme';

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: '"Syne", sans-serif',
    body: '"Lora", serif',
    mono: '"DM Mono", monospace',
  },
  colors: {
    navy: {
      950: '#050c1a',
      900: '#0a1628',
      800: '#0f2040',
      700: '#162d58',
    },
    ice: {
      DEFAULT: '#c8dff0',
      dim: 'rgba(200, 223, 240, 0.55)',
    },
    signal: {
      DEFAULT: '#4af0c4',
      dim: 'rgba(74, 240, 196, 0.5)',
    },
    amber: {
      DEFAULT: '#e8a44a',
      dim: 'rgba(232, 164, 74, 0.5)',
    },
    // Chakra color scale mappings for compatibility
    teal: {
      50: '#e6fff9',
      100: '#b3ffe9',
      200: '#80ffd9',
      300: '#4dffc9',
      400: '#1affa5',
      500: '#4af0c4',
      600: '#00c99a',
      700: '#009973',
      800: '#00664d',
      900: '#003326',
    },
    orange: {
      50: '#fdf3e6',
      100: '#f9e1b9',
      200: '#f5ce8c',
      300: '#f1bc5f',
      400: '#eda932',
      500: '#e8a44a',
      600: '#c47a1a',
      700: '#945c14',
      800: '#633d0d',
      900: '#311f07',
    },
    gray: {
      50: '#c8dff0',
      100: '#b0cde4',
      200: '#94b4d4',
      300: '#7a9bc4',
      400: '#5f82b4',
      500: '#4a6a9a',
      600: '#395280',
      700: '#2a3d66',
      800: '#1b2a4d',
      900: '#0a1628',
    },
  },
  components: {
    Link: defineStyleConfig({
      baseStyle: {
        color: 'signal.DEFAULT',
        textDecoration: 'none',
        _hover: {
          textDecoration: 'underline',
          color: 'signal.DEFAULT',
        },
      },
    }),
    Text: defineStyleConfig({
      baseStyle: {
        mb: 3,
        color: 'rgba(200, 223, 240, 0.78)',
        fontFamily: 'Lora, serif',
      },
    }),
    Heading: defineStyleConfig({
      baseStyle: {
        mb: 3,
        fontFamily: '"Syne", sans-serif',
        color: '#c8dff0',
        letterSpacing: '-0.02em',
      },
    }),
    Tag: defineStyleConfig({
      baseStyle: {
        fontFamily: '"DM Mono", monospace',
        fontSize: '0.58rem',
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
      },
      variants: {
        subtle: {
          container: {
            background: 'rgba(74, 240, 196, 0.07)',
            color: '#4af0c4',
            border: '1px solid rgba(74, 240, 196, 0.2)',
            borderRadius: '1px',
          },
        },
      },
    }),
    Button: defineStyleConfig({
      baseStyle: {
        fontFamily: '"DM Mono", monospace',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        borderRadius: '1px',
      },
    }),
    Divider: defineStyleConfig({
      baseStyle: {
        borderColor: 'rgba(74, 240, 196, 0.15)',
      },
    }),
  },
  styles: {
    global: {
      html: {
        scrollBehavior: 'smooth',
      },
      body: {
        backgroundColor: 'navy.950',
        color: 'ice.DEFAULT',
        fontFamily: '"DM Mono", monospace',
      },
      '::selection': {
        background: 'rgba(74, 240, 196, 0.2)',
        color: '#4af0c4',
      },
    },
  },
};

export default extendTheme(proTheme, theme);

export const baseTheme = proTheme;
